import { memo, useState, useEffect } from "react";
import { Grid, Paper, TextField, Typography, Box } from "@mui/material";
import { useDebouncedEffect } from "../hooks/useDebouncedEffect";
import type { DescriptionProps } from "../types/note";

const Description = memo(function Description({
    descripcion,
    setDescripcion,
    maxLen = 2000,
    onDebouncedChange,
    debounceDelay = 500,
}: DescriptionProps) {
    const [localValue, setLocalValue] = useState(descripcion);

    // Mantener sincronizado si cambia desde fuera
    useEffect(() => {
        setLocalValue(descripcion);
    }, [descripcion]);

    // ⏳ Disparar callback debounced sin afectar la escritura
    useDebouncedEffect(() => {
        if (!onDebouncedChange) return;
        onDebouncedChange(localValue);
    }, [localValue, onDebouncedChange], debounceDelay);

    const chars = localValue.length;

    const handleChange = (value: string) => {
        if (maxLen && value.length > maxLen) return;
        setLocalValue(value);   // reactivo inmediato
        setDescripcion(value);  // mantiene el estado padre
    };

    return (
        <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
            <Box display="flex" alignItems="center" mb={1}>
                <Typography variant="subtitle1" fontWeight={600}>
                    Nota adicional
                </Typography>
                <Box ml="auto">
                    <Typography variant="caption" color="text.secondary">
                        {chars}/{maxLen}
                    </Typography>
                </Box>
            </Box>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        id="nota-adicional"
                        name="notaAdicional"
                        placeholder="Nota..."
                        value={localValue}
                        onChange={(e) => handleChange(e.target.value)}
                        multiline
                        rows={4}
                        fullWidth
                        variant="outlined"
                        size="small"
                        inputProps={{ "aria-label": "Nota adicional" }}
                        sx={{ "& .MuiInputBase-root": { alignItems: "flex-start" } }}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
});

export default Description;
